import * as TypeGraphQL from "type-graphql";
export var AlertCategory;
(function (AlertCategory) {
    AlertCategory["EVENT_RISK"] = "EVENT_RISK";
    AlertCategory["MARKET_RISK"] = "MARKET_RISK";
    AlertCategory["SYSTEM"] = "SYSTEM";
    AlertCategory["TRADE"] = "TRADE";
    AlertCategory["PORTFOLIO"] = "PORTFOLIO";
})(AlertCategory || (AlertCategory = {}));
TypeGraphQL.registerEnumType(AlertCategory, {
    name: "AlertCategory",
    description: undefined,
});
//# sourceMappingURL=AlertCategory.js.map